/**
 * Prevent hash navigation when reopening CookieYes consent settings.
 */
export function initCookieYesLinks() {
	document.addEventListener('click', (event) => {
		const link = event.target.closest('a.cky-banner-element');
		if (!link) {
			return;
		}

		event.preventDefault();
	});
}
